import Basic from "./basic.jsx";
import Error from "./error.jsx";
import Label from "./label.jsx";

export default {
  Basic,
  Error,
  Label
};
